// extracted by mini-css-extract-plugin
export default {"upperPart":"Forms_upperPart__9hVLG","tabs":"Forms_tabs__e+Ynn","activeTab":"Forms_activeTab__SnpLr","tabOptions":"Forms_tabOptions__Ex+XS","externalTab":"Forms_externalTab__gaVqs"};